import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c19fnwt6";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const innerContentReadOnlyCss = "i19lcgh1";
const innerContentDisabledCss = "i1cmi7e0";
const innerContentCss = "itf4zs6";
export const InnerContent = forwardRef((props, ref) => {
  const {
    readOnly,
    disabled,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const spacing = 0;
  return <Component ref={ref} {...restProps} spacing={spacing} className={classNames(innerContentCss, {
    [innerContentReadOnlyCss]: readOnly,
    [innerContentDisabledCss]: disabled
  }, props.className)} />;
});
const contentCss = "c1pv7xgo";
export const Content = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentCss, props.className)} />;
});
const actionSectionHasBadgeCss = "ablud4";
const actionSectionCss = "a2gn215";
export const ActionSection = forwardRef((props, ref) => {
  const {
    hasBadge,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(actionSectionCss, {
    [actionSectionHasBadgeCss]: hasBadge
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");